/* Base translations · Settings — moved unchanged out of lib/i18n.js (STEP 6 · split 6f).
   Top-level keys owned by this file (no other base file and not i18n.js define them): settings. */
export const I18N_BASE_SETTINGS = {
  en: {
    settings: {
      newUserPasswordLabel: "Password (optional — a random temporary password is generated if blank)",
      locks: {
        title: "Locked sign-ins",
        hint: "Too many failed attempts lock an account (5) or an address (30) for 15 minutes. Unlock clears the lock now; the failed-attempt count is kept, so one more wrong password locks again until a sign-in succeeds.",
        none: "No sign-in is locked at the moment.",
        refresh: "Look again",
        colWhat: "Locked",
        colAddress: "Address",
        colSince: "Locked at",
        colUntil: "Unlocks at",
        address: "Address",
        addressLockedToo: "address locked too",
        unlock: "Unlock",
        unlockAddress: "Unlock address",
        confirm: "Unlock {who} now? The failed-attempt count is kept.",
        unlocked: "Unlocked: {who}",
        unlockFailed: "The lock could not be cleared",
        kind: { login_account: "sign-in", twofa_account: "2FA code", mail_account: "e-mails", login_ip: "sign-in", mail_ip: "e-mails", public_ip: "public" },
      },
      newUserPasswordPlaceholder: "Leave blank for a random temporary password (shown once)",
      title: "Settings",
      orgSection: "Organization",
      teamSection: "Team members",
      branding: "Firm branding",
      logo: "Logo",
      noLogo: "No logo",
      uploadLogo: "Upload logo",
      orgName: "Organization name",
      primaryColor: "Primary color",
      secondaryColor: "Sidebar color",
      brandingSaved: "Branding saved",
      team: "Team members",
      inviteMember: "Invite member",
      role: "Role",
      inviteHint: "A single-use invite link will be generated and copied to your clipboard.",
      createInvite: "Create invite",
      inviteCreated: "Invite created — link copied to clipboard",
      pendingInvites: "Pending invites",
      noInvites: "No pending invites",
      copyLink: "Copy link",
      emailSent: "Email sent",
      emailPending: "Invitation link only — the e-mail was not sent",
      emailNotSent: "Invitation saved, but the e-mail could not be sent. Use the Send button when e-mail works.",
      resendInvite: "Send to {email}",
      inviteResent: "Invitation sent to {email}.",
      emailSentTo: "Invite emailed to",
    },
  },
  ar: {
    settings: {
      newUserPasswordLabel: "كلمة المرور (اختياري — تُولَّد كلمة مرور مؤقتة عشوائية إذا تُركت فارغة)",
      locks: {
        title: "عمليات تسجيل الدخول المقفلة",
        hint: "تؤدي المحاولات الفاشلة الكثيرة إلى قفل الحساب (5) أو العنوان (30) لمدة 15 دقيقة. يزيل «إلغاء القفل» القفل فورًا؛ ويُحتفظ بعدد المحاولات الفاشلة، فكلمة مرور خاطئة واحدة أخرى تقفل مجددًا حتى ينجح تسجيل الدخول.",
        none: "لا يوجد تسجيل دخول مقفل حاليًا.",
        refresh: "تحقق مرة أخرى",
        colWhat: "المقفل",
        colAddress: "العنوان",
        colSince: "وقت القفل",
        colUntil: "ينتهي القفل في",
        address: "العنوان",
        addressLockedToo: "العنوان مقفل أيضًا",
        unlock: "إلغاء القفل",
        unlockAddress: "إلغاء قفل العنوان",
        confirm: "إلغاء قفل {who} الآن؟ يُحتفظ بعدد المحاولات الفاشلة.",
        unlocked: "تم إلغاء القفل: {who}",
        unlockFailed: "تعذر إزالة القفل",
        kind: { login_account: "تسجيل الدخول", twofa_account: "رمز المصادقة الثنائية", mail_account: "الرسائل", login_ip: "تسجيل الدخول", mail_ip: "الرسائل", public_ip: "عام" },
      },
      newUserPasswordPlaceholder: "اتركه فارغًا لكلمة مرور مؤقتة عشوائية (تُعرض مرة واحدة)",
      title: "الإعدادات",
      orgSection: "المؤسسة",
      teamSection: "أعضاء الفريق",
      branding: "هوية الشركة",
      logo: "الشعار",
      noLogo: "لا يوجد شعار",
      uploadLogo: "رفع الشعار",
      orgName: "اسم المؤسسة",
      primaryColor: "اللون الأساسي",
      secondaryColor: "لون الشريط الجانبي",
      brandingSaved: "تم حفظ الهوية",
      team: "أعضاء الفريق",
      inviteMember: "دعوة عضو",
      role: "الدور",
      inviteHint: "سيتم إنشاء رابط دعوة ونسخه إلى الحافظة.",
      createInvite: "إنشاء دعوة",
      inviteCreated: "تم إنشاء الدعوة — الرابط في الحافظة",
      pendingInvites: "الدعوات المعلقة",
      noInvites: "لا توجد دعوات معلقة",
      copyLink: "نسخ الرابط",
      emailSent: "تم إرسال البريد",
      emailPending: "رابط فقط (البريد غير مُهيأ)",
      emailNotSent: "تم حفظ الدعوة، لكن تعذّر إرسال البريد الإلكتروني. استخدم زر «إرسال إلى» عندما يعمل البريد.",
      resendInvite: "إرسال إلى {email}",
      inviteResent: "أُرسلت الدعوة إلى {email}.",
      emailSentTo: "تم إرسال الدعوة إلى",
    },
  },
};

export default I18N_BASE_SETTINGS;
